

export const getQuickTimeRange = (type="string", timeRange) => {

    let timeRangeAsStr = '';
    let timeRangeAsObj = {};

    const setStartEndTime = (today = new Date()) => {
        const areDatesSame = (d1, d2) =>{
            const res = (d1.getFullYear() === d2.getFullYear() &&
            d1.getMonth() === d2.getMonth() &&
            d1.getDate() === d2.getDate()) ? true : false;
            return res;
        }

        let startDateTime=new Date(today);
        let endDateTime=new Date(today);

        if (timeRange === 'today'){
            startDateTime.setDate(today.getDate());
            startDateTime.setHours(0, 0, 0, 0);
            endDateTime = new Date(endDateTime);
        } else if (timeRange === 'yesterday'){
            startDateTime.setDate(today.getDate() - 1);
            startDateTime.setHours(0, 0, 0, 0);
            endDateTime.setDate(today.getDate() - 1);
            endDateTime.setHours(23, 59, 59, 999);
        } else if (timeRange === 'thisWeek'){
            const dayOfWeek = today.getDay();
            startDateTime.setDate(today.getDate() - dayOfWeek);
            startDateTime.setHours(0, 0, 0, 0);
            if (areDatesSame(today, new Date())){
                endDateTime = new Date(today);
            } else {
                endDateTime.setDate(today.getDate() + (dayOfWeek + 6));
                endDateTime.setHours(23, 59, 59, 999);
            }
        } else if (timeRange === 'lastWeek'){
            const dayOfWeek = today.getDay();
            startDateTime.setDate(today.getDate() - (dayOfWeek + 7));
            startDateTime.setHours(0, 0, 0, 0);
            endDateTime.setDate(today.getDate() - (dayOfWeek +1)); 
            endDateTime.setHours(23, 59, 59, 999);
        } else if (timeRange === 'thisMonth'){
            startDateTime= new Date(today.getFullYear(), today.getMonth(), 1);
            startDateTime.setHours(0, 0, 0, 0);
            if (areDatesSame(today, new Date())){
                endDateTime = new Date(endDateTime);
            } else {
                endDateTime = new Date(today.getFullYear(), today.getMonth()+1, 0);
                endDateTime.setHours(23, 59, 59, 999);
            }
        } else if (timeRange === 'lastMonth'){
            const thisMonth = new Date(today.getFullYear(), today.getMonth(), 1);
            const lastMonth = new Date(thisMonth)
            lastMonth.setDate(0);
            startDateTime = new Date(lastMonth.getFullYear(), lastMonth.getMonth())
            startDateTime.setHours(0, 0, 0, 0);
            endDateTime = new Date(lastMonth);
            endDateTime.setHours(23, 59, 59, 999);
        }
        timeRangeAsStr = `${startDateTime.toLocaleString().replace(/\//g, '-')} to ${endDateTime.toLocaleString().replace(/\//g, '-')}`;
        timeRangeAsObj = ({startTime: startDateTime.getTime(), endTime: endDateTime.getTime() })
    }

    setStartEndTime();
    let retTimeRange;
    if (type === 'string'){
        retTimeRange =  timeRangeAsStr;
    } else if (type === 'obj') {
        retTimeRange = timeRangeAsObj;
    }
    return retTimeRange;

}
